import { render } from "./AccordionContainer.vue?vue&type=template&id=7945776c&scoped=true"
import script from "./AccordionContainer.vue?vue&type=script&lang=js"
export * from "./AccordionContainer.vue?vue&type=script&lang=js"

import "./AccordionContainer.vue?vue&type=style&index=0&id=7945776c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7945776c"]])

export default __exports__